module.exports = __webpack_public_path__ + "static/media/Badge_SvgFormationRSE.1e7dcfcd.svg";